/* Mon Livre de Vie — dates civiles, téléphone et campagnes 2026.
   Les remises doivent aussi être créées dans Shopify. Fin exclusive. */
(function (root, factory) {
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  else root.MLVCommerce = api;
})(typeof window !== 'undefined' ? window : globalThis, function () {
  'use strict';
  var campaigns = [
    {code:'MLVSEP08', name:'La semaine des souvenirs', start:'2026-09-08T00:00:00+02:00', end:'2026-09-15T00:00:00+02:00'},
    {code:'PAPY2026', name:'Fête des grands-pères', start:'2026-09-20T00:00:00+02:00', end:'2026-10-05T00:00:00+02:00'},
    {code:'MLVOCT06', name:'La semaine des souvenirs', start:'2026-10-06T00:00:00+02:00', end:'2026-10-19T00:00:00+02:00'},
    {code:'MLVOCT20', name:'La semaine des souvenirs', start:'2026-10-20T00:00:00+02:00', end:'2026-10-27T00:00:00+01:00'},
    {code:'MLVNOV03', name:'La semaine des souvenirs', start:'2026-11-03T00:00:00+01:00', end:'2026-11-10T00:00:00+01:00'},
    {code:'MLVNOV17', name:'La semaine des souvenirs', start:'2026-11-17T00:00:00+01:00', end:'2026-11-24T00:00:00+01:00'}
  ];
  function active(now) {
    var time = now == null ? Date.now() : Number(now);
    return campaigns.find(function (p) { return time >= Date.parse(p.start) && time < Date.parse(p.end); }) || null;
  }
  function countdown(end, now) {
    var remaining = Math.max(0, Math.ceil((Date.parse(end) - (now == null ? Date.now() : now)) / 1000));
    var days = Math.floor(remaining / 86400);
    var hours = Math.floor(remaining % 86400 / 3600);
    var minutes = Math.floor(remaining % 3600 / 60);
    return days + ' j ' + String(hours).padStart(2,'0') + ' h ' + String(minutes).padStart(2,'0') + ' min ' + String(remaining % 60).padStart(2,'0') + ' s';
  }
  function parisDate(now) {
    var parts = new Intl.DateTimeFormat('en-GB', {timeZone:'Europe/Paris', year:'numeric', month:'2-digit', day:'2-digit'}).formatToParts(new Date(now == null ? Date.now() : now));
    function part(type) { return parts.find(function (p) { return p.type === type; }).value; }
    return part('year') + '-' + part('month') + '-' + part('day');
  }
  function validDate(value) {
    if (!/^\d{4}-\d{2}-\d{2}$/.test(value || '')) return false;
    var date = new Date(value + 'T12:00:00Z');
    return !isNaN(date.getTime()) && date.toISOString().slice(0,10) === value;
  }
  function displayDate(value) {
    return validDate(value) ? new Intl.DateTimeFormat('fr-FR', {timeZone:'UTC', weekday:'long', day:'numeric', month:'long', year:'numeric'}).format(new Date(value + 'T12:00:00Z')) : '';
  }
  function normalizePhone(code, input) {
    var value = String(input || '').trim();
    if (/[^\d\s+().-]/.test(value)) return {valid:false, message:'Vérifiez le numéro WhatsApp.'};
    value = value.replace(/[\s().-]/g,'').replace(/^00/,'+');
    var prefix = String(code || '+33').replace(/\D/g,'');
    if (value[0] === '+') {
      var known = ['351','352','353','358','376','377','33','32','41','44','49','34','39','55','1'];
      prefix = known.find(function (p) { return value.slice(1).startsWith(p); }) || prefix;
      if (!value.slice(1).startsWith(prefix)) return {valid:false, message:'Choisissez le pays correspondant au numéro.'};
      value = value.slice(1 + prefix.length);
    }
    // Le zéro initial est significatif pour les numéros fixes italiens.
    if (prefix !== '39') value = value.replace(/^0/,'');
    var e164 = '+' + prefix + value;
    var rules = {'33':[9,9], '351':[9,9], '32':[8,9], '41':[9,9], '44':[10,10], '34':[9,9], '1':[10,10], '55':[10,11]};
    var rule = rules[prefix] || [6,12];
    var valid = /^\+[1-9]\d{7,14}$/.test(e164) && value.length >= rule[0] && value.length <= rule[1];
    return {valid:valid, e164:e164, national:value, code:'+' + prefix, message:valid ? '' : 'Vérifiez le pays et le numéro WhatsApp.'};
  }
  function money(cents) { return new Intl.NumberFormat('fr-FR', {style:'currency', currency:'EUR'}).format(Math.round(cents) / 100); }
  var memo15 = {code:'MEMO15', name:'Votre offre souvenirs', value:15, scope:'order', source:'link'};
  // En centimes, sur le livre ET toutes les options. Sans argument, les
  // anciens appels conservent les 10 % du calendrier.
  function discounted(cents, promotion) {
    var percent = promotion && promotion.value != null ? Number(promotion.value) : 10;
    return Math.round(Math.round(cents) * (100 - percent) / 100);
  }
  function cartHasPromotion(cart, promotion) {
    if (!cart || !promotion) return false;
    var applications = (cart.cart_level_discount_applications || []).slice();
    (cart.items || []).forEach(function (item) {
      (item.line_level_discount_allocations || []).forEach(function (allocation) {
        if (allocation.discount_application) applications.push(allocation.discount_application);
      });
    });
    if (applications.some(function (application) {
      return String(application.title || '').trim().toUpperCase() === promotion.code &&
        application.type === 'discount_code' && application.value_type === 'percentage' &&
        Number(application.value) === promotion.value;
    })) return true;
    return (cart.discount_codes || []).some(function (discount) {
      return String(discount.code || '').trim().toUpperCase() === promotion.code && discount.applicable === true;
    });
  }
  return {campaigns:campaigns, memo15:memo15, active:active, countdown:countdown, parisDate:parisDate, validDate:validDate, displayDate:displayDate, normalizePhone:normalizePhone, money:money, discounted:discounted, cartHasPromotion:cartHasPromotion};
});
